import Drawer from '@mui/material/Drawer'
import styled from 'styled-components'

export const StyledWellnessTileDrawer = styled(Drawer)`
  z-index: 1190 !important;

  .MuiBackdrop-root {
    background: rgba(11, 12, 16, 0.28);
    backdrop-filter: blur(2px);
  }

  .MuiPaper-root {
    width: min(1120px, 88vw);
    max-width: 100vw;
    background: #1e1f23;
    color: #ffffff;
    overflow: hidden;
    box-shadow: -24px 0 70px rgba(0, 0, 0, 0.38);

    @media (max-width: 720px) {
      width: 100vw;
    }
  }
`

export const WellnessTileDrawerShell = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #1e1f23;
`

export const WellnessTileDrawerHeader = styled.header`
  position: sticky;
  top: 0;
  z-index: 5;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 16px;
  align-items: center;
  min-height: 72px;
  padding: 14px 22px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(30, 31, 35, 0.9);
  backdrop-filter: blur(18px);

  @media (max-width: 720px) {
    min-height: 64px;
    padding: 12px 14px;
    gap: 10px;
  }
`

export const WellnessTileDrawerTitleBlock = styled.div`
  min-width: 0;
`

export const WellnessTileDrawerBackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  color: rgba(255, 255, 255, 0.72);
  font-family: Outfit, sans-serif;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;

  span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:hover {
    color: #ffffff;
  }
`

export const WellnessTileDrawerTitle = styled.h2`
  margin: 6px 0 0;
  color: #ffffff;
  font-family: Outfit, sans-serif;
  font-size: 23px;
  font-weight: 700;
  line-height: 1.1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 720px) {
    font-size: 19px;
  }
`

export const WellnessTileDrawerActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const WellnessTileDrawerIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.14);
  }

  @media (max-width: 720px) {
    width: 34px;
    height: 34px;
  }
`

export const WellnessTileDrawerBody = styled.div`
  flex: 1;
  overflow: auto;
  overscroll-behavior: contain;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 999px;
  }
`
